<template>
  <div id="support-admin-ticket-modal">

    <ErrorPopup :error="error" />

    <memlist-modal ref="edit-modal" size="xl">


      <div class="ml-tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
            :disabled="tab.disabled"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">
            <SupportAdminTicketForm
              class="mr-8 mb-8"
              :item="local_item"
              @created="ticket_created"
              @updated="ticket_updated"
              @cancel="()=>{this.$refs['edit-modal'].hide();}"
            />
          </div>
          <div v-show="active_tab === 1">
              
            <SupportAdminTicketMessages
              v-if="local_item && local_item.messages"
              :items="local_item.messages"
              :ticket="local_item"
              style="min-height: 640px;"
            />
          </div>
        </div>
      </div>

    </memlist-modal>

  </div>
</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import SupportAdminTicketForm from '@/view/pages/ml/support/SupportAdminTicketForm.vue';
import SupportAdminTicketMessages from '@/view/pages/ml/support/SupportAdminTicketMessages.vue';

import ErrorPopup from '@/view/components/ErrorPopup.vue';


export default {
  name: 'SupportAdminTicketModal',
  components: {
    SupportAdminTicketForm,
    SupportAdminTicketMessages,
    ErrorPopup
  },
  watch: {
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_item = { ...this.item };
      }
    }
  },
  mixins: [ toasts ],
  computed: {
    tabs() {
      let base = [
        { label: 'SUPPORT.TICKET.DETAILS', disabled: false },
        { label: 'SUPPORT.TICKET.MESSAGES', disabled: false },

      ];
      
      return base;
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId']),

  },
  props: ['item'],
  emits: ['created', 'updated'],
  async mounted() {
    if (this.item) {
      this.local_item = { ...this.item }
    }
  },
  methods: {

    show() {
      this.$refs['edit-modal'].show();

      this.$nextTick(() => {

      });
    },

    hide() {
      this.$refs['edit-modal'].hide();

      this.$nextTick(() => {

      });
    },

    ticket_created(item) {
      this.$emit('created', item);

      this.hide();

      this.toastr('success', this.$t('COMMON.SUCCESS'), this.$t('SUPPORT.TICKET.CREATED'));
    },

    ticket_updated(item) {
      this.$emit('updated', item);

      this.hide();

      this.toastr('success', this.$t('COMMON.SUCCESS'), this.$t('SUPPORT.TICKET.UPDATED'));
    },

    edit_user_clicked(item) {
      this.local_item = { ...item };
      this.$refs['edit-modal'].show();
    },

    new_user_clicked() {
      this.local_item = {};
      this.$refs['edit-modal'].show();
    },

  },
  data() {
    return {
      active_tab: 0,
      error: null,

      local_item: null

    };
  }

};
</script>


